import React from "react";
import Loader from "react-loader-spinner";
import styled from "styled-components";

const PageLoaderBlock = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  svg {
    height: 70px !important;
    width: 70px !important;
  }
`;

export const ButtonLoader = () => (
  <Loader type="Oval" color="white" width="20" height="20" />
);

export const FileLoader = () => (
  <Loader type="ThreeDots" color="#7a8088" width="5" height="5" />
);

export const TripLoader = () => (
  <Loader type="ThreeDots" color="#7a8088" width="18" height="18" />
);

export const PageLoader = () => (
  <PageLoaderBlock>
    <Loader type="TailSpin" color="#D22833" width="56" height="56" />
  </PageLoaderBlock>
);

export const BlockLoader = ({ marginTop, marginBottom }) => (
  <div
    className="block-loader"
    style={{
      marginTop: marginTop || "0px",
      marginBottom: marginBottom || "0px",
    }}
  >
    <Loader type="TailSpin" color="#D22833" width="46" height="46" />
  </div>
);

// const PageLoaderBlock = styled.div`
// 	height: 100vh;
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	position: absolute;
// 	width: 100%;
// 	top: 0;
// 	left: 0;
// 	svg {
// 		height: 70px !important;
// 		width: 70px !important;
// 	}
// `;

// export const OverlayLoader = () => (
//   <div id="lottie" className="uk-open uk-modal" data-uk-modal>
//     <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical lottie-modal is-transparent">
//       <div className="lds-ring">
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//       </div>
//       <p>Updating Payment</p>
//     </div>
//   </div>
// );
